import React, { Component } from 'react';
import { CSSTransition } from './CSSTransition';
import { withTranslation } from 'react-i18next';

class IdleTimerPrompt extends Component {
	constructor(props) {
		super(props);

		this.state = {
			css: props.CSSModules["IdleTimerPrompt"],
		};

		this.promptRef = React.createRef();
	}

	componentDidMount() { }

	render() {
		const {
			css
		} = this.state;
		// For translation
		const { t } = this.props;
		return (
			<CSSTransition
				in={this.props.showIdlePrompt}
				appear={this.props.showIdlePrompt}
				unmountOnExit={true}
				timeout={800}
				classNames='contentFade'
				nodeRef={this.promptRef}>
					<div ref={this.promptRef} className={css.promptContainer} onClick={() => {this.props.clearShowIdlePrompt()}}>
                		 <button className={css.promptBtn}>{t("idleTouchToContinueLabel")}</button>
           			 </div>
			</CSSTransition>
		);
	}
}

export default withTranslation()(IdleTimerPrompt);